export class Brod2ProductCategoryValueConverter {
  static x = {
    BEER: 'Øl',
    CIDER: 'Cider',
    READY_TO_DRINK: 'Ferdigdrink',
    SODA: 'Brus',
    ENERGY_DRINK: 'Energidrikk',
    WATER: 'Vann',
  };

  toView(value) {
    return Brod2ProductCategoryValueConverter.toView(value);
  }

  static toView(value) {
    return this.x[value];
  }
}
